export default "__VITE_ASSET__P5pKCBl1__"